import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["custom", "customFunction"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Link } from '@uswitch/ev-core/react';
import customValidations from '../../helpers/form-validations';
import { SimpleInput } from '../../elements/simple-input';
import customFunctions from '../../helpers/form-validation-functions';
import SimpleRadio from '../../elements/simple-radio';
import SimpleCheckbox from '../../elements/simple-checkbox';
import SimpleDropDown from '../../elements/simple-drop-down';
import InputAlert from '../../elements/input-alert';
import AddressHistory from '../../compounds/address-history';
import AddressInput from '../../compounds/address-input';
import InputMask from 'react-input-mask';
import SuggestionBox from '../../elements/suggestion-box';
import SLIDER_STYLES from '../../../constants/slider-styles';
import formatter from '../../helpers/form-summary-formatter';
import masks from '../../helpers/form-masks';
import FormatStringToLocale from '../../helpers/number-formatter';
import { Checkbox } from '@uswitch/spark';
import { useComponentTracking } from '@uswitch/ev-utils/component-events';
import { getConsentText } from '@uswitch/rvuconsent';
import { isValidNumber } from '../../helpers/field-input-validation';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var FormStepField = function FormStepField(_ref) {
  var field = _ref.field,
      register = _ref.register,
      triggerValidation = _ref.triggerValidation,
      errors = _ref.errors,
      setValue = _ref.setValue,
      getValues = _ref.getValues,
      formType = _ref.formType,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      goToPage = _ref.goToPage,
      updateCompletionState = _ref.updateCompletionState,
      onKeyDownFunction = _ref.onKeyDownFunction,
      _ref$isChild = _ref.isChild,
      isChild = _ref$isChild === void 0 ? false : _ref$isChild,
      _ref$trackInteraction = _ref.trackInteraction,
      trackInteraction = _ref$trackInteraction === void 0 ? function () {} : _ref$trackInteraction,
      sectionTitle = _ref.sectionTitle,
      index = _ref.index,
      addressLookup = _ref.addressLookup;
  var _field$validation = field.validation;
  _field$validation = _field$validation === void 0 ? {} : _field$validation;

  var custom = _field$validation.custom,
      customFunction = _field$validation.customFunction,
      rest = _objectWithoutProperties(_field$validation, _excluded);

  var validation = field.validation,
      name = field.name,
      type = field.type,
      children = field.children,
      placeholder = field.placeholder,
      label = field.label,
      _field$options = field.options,
      options = _field$options === void 0 ? [] : _field$options,
      _field$inputMask = field.inputMask;
  _field$inputMask = _field$inputMask === void 0 ? {} : _field$inputMask;
  var customMask = _field$inputMask.customMask,
      mask = _field$inputMask.mask,
      _field$value = field.value,
      value = _field$value === void 0 ? '' : _field$value,
      prefix = field.prefix,
      suffix = field.suffix,
      text = field.text,
      links = field.links,
      uppercase = field.uppercase,
      description = field.description,
      inputSize = field.inputSize,
      title = field.title,
      summaryList = field.summaryList,
      suggestionData = field.suggestionData,
      _field$consentType = field.consentType,
      consentType = _field$consentType === void 0 ? null : _field$consentType,
      _field$consentName = field.consentName,
      consentName = _field$consentName === void 0 ? null : _field$consentName,
      fieldVariant = field.fieldVariant,
      subtext = field.subtext,
      minimumRequiredYears = field.minimumRequiredYears,
      privacyPolicyLink = field.privacyPolicyLink;
  var trackComponent = useComponentTracking();
  var isSingleRow = fieldVariant === 'singleRow';

  if (custom && customValidations[custom]) {
    validation = _objectSpread(_objectSpread({}, rest), customValidations[custom]);
  }

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      consentObj = _React$useState2[0],
      setConsentObj = _React$useState2[1];

  React.useEffect(function () {
    if (consentName && consentType) {
      getConsentText({
        consentName: consentName,
        consentType: consentType
      }).then(function (data) {
        if (data) setConsentObj(data);
      });
    }
  }, []);

  var variantPath = function variantPath(element) {
    return "elements.form.variants.".concat(variant, ".").concat(element);
  };

  var ref = validation ? register(validation) : register;
  var props = {
    name: name,
    placeholder: placeholder,
    errors: errors,
    setValue: setValue,
    options: options,
    uppercase: uppercase,
    inputSize: inputSize
  };
  var getLinks = {
    termsAndConditions: links === null || links === void 0 ? void 0 : links.termsAndConditions,
    privacyPolicy: links === null || links === void 0 ? void 0 : links.privacyPolicy
  };
  var textField = (type === 'text' || type === 'redirect') && text.replace(/\$\{([a-z]+)\}/gi, function (original, match) {
    return match in getLinks ? getLinks[match] : original;
  }); // We also support named validation functions

  if (_typeof(customFunction) === 'object') {
    var validateFunctions = {};
    var hasValidationFunctions = false;

    for (var _key in customFunction) {
      if (customFunctions[_key]) {
        // For each custom function used in the data, generate the corresponding validation function
        validateFunctions[_key] = customFunctions[_key](_objectSpread(_objectSpread({}, customFunction[_key]), {}, {
          getValues: getValues
        }));
        hasValidationFunctions = true;
      }
    }

    if (hasValidationFunctions) {
      // See Validate option in https://react-hook-form.com/v5/api/#register
      validation.validate = validateFunctions;
    }
  }

  if (customMask && masks[customMask] && customMask !== 'currency' && customMask !== 'numeric') {
    mask = masks[customMask];
  }

  var onChange = function onChange(e) {
    var value = e.target.value;

    if (customMask === 'currency') {
      var currencyString = FormatStringToLocale(value);
      return setValue(name, currencyString);
    }

    if (customMask === 'numeric') {
      var currentValue = isValidNumber(value) ? value : value.slice(0, -1);
      return setValue(name, currentValue);
    }

    setValue(name, value);
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13) {
      if (onKeyDownFunction.length) {
        e.preventDefault();
        var func = onKeyDownFunction[0];
        return func();
      }
    }
  };

  var handleTrackInteraction = function handleTrackInteraction(e) {// removed for now due to bug
  };

  var displayLabel = function displayLabel(label) {
    return _jsx("label", {
      sx: {
        variant: formType === 'calculator' ? variantPath('label.variants.calculator') : variantPath('label')
      },
      htmlFor: label,
      children: label
    });
  };

  var displayDescription = function displayDescription(description) {
    var journeyVariant = variant === 'journey';
    var sectionNameVariant = sectionTitle && journeyVariant && index !== 0;
    return _jsx("p", {
      sx: {
        variant: sectionNameVariant ? variantPath('description.sectionName') : variantPath('description')
      },
      children: description
    });
  };

  if (errors[name]) {
    trackComponent('Form Event', 'error', _defineProperty({}, name, errors[name].message));
    trackInteraction('GA Validation Error Triggered', 'Site Interaction', "".concat(name, ":").concat(errors[name].message));
  }

  return _jsxs(React.Fragment, {
    children: [type === 'slider' ? _jsxs("div", {
      sx: SLIDER_STYLES,
      children: [_jsx("h2", {
        children: label
      }), _jsx("input", {
        type: "range",
        min: "1",
        max: "5",
        step: "1",
        onChange: function onChange(e) {
          return console.log(e.target.value);
        },
        list: "tickmarks"
      }), _jsxs("datalist", {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          color: 'black'
        },
        id: "tickmarks",
        children: [_jsx("option", {
          value: "1",
          label: "Not at all"
        }), _jsx("option", {
          value: "3",
          label: "Somewhat"
        }), _jsx("option", {
          value: "5",
          label: "Very"
        })]
      })]
    }) : null, type === 'address-lookup' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.wrapper')
      },
      children: [label && displayLabel(label), _jsx(AddressHistory, {
        minimumRequiredYears: minimumRequiredYears,
        name: name,
        lookup: addressLookup,
        label: title,
        onChange: function onChange() {
          // Only do on change validation if we have outstading errors to resolve
          if (errors[name]) {
            triggerValidation(name);
          }
        },
        ref: ref,
        error: errors[name],
        formVariant: variant
      }), subtext ? _jsx("p", {
        sx: {
          textAlign: 'left'
        },
        children: subtext
      }) : null]
    }) : null, type === 'address-input' ? [label && displayLabel(label), _jsx(AddressInput, {
      name: name,
      lookup: addressLookup,
      label: title,
      onChange: function onChange() {
        if (errors[name]) {
          triggerValidation(name);
        }
      },
      ref: ref,
      error: errors[name],
      formVariant: variant
    }, "1"), subtext ? _jsx("p", {
      sx: {
        textAlign: 'left'
      },
      children: subtext
    }, "2") : null] : null, type === 'hidden' ? _jsx("input", {
      type: "hidden",
      name: name,
      value: value,
      ref: ref
    }) : null, type === 'querystring' ? _jsx("input", {
      type: "hidden",
      name: name,
      ref: ref,
      placeholder: placeholder
    }) : null, type === 'dropdown' ? _jsxs("div", {
      sx: {
        variant: formType === 'calculator' ? variantPath('input.calculator.dropdown') : isSingleRow ? variantPath('input.singleRow') : variantPath('input.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsx("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('wrapper.variants.calculator') : variantPath('wrapper.base')
        },
        children: _jsx(SimpleDropDown, {
          name: name,
          options: options,
          placeholder: placeholder,
          hasError: errors[name],
          ref: ref,
          handleTrackInteraction: handleTrackInteraction,
          isSingleRow: isSingleRow
        })
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error')
        },
        children: errors[name].message
      }) : null, subtext && _jsx("p", {
        sx: {
          textAlign: 'left'
        },
        children: subtext
      })]
    }) : null, type === 'wrapper' ? _jsxs("div", {
      sx: {
        variant: formType === 'calculator' ? variantPath('input.wrapper.calculator') : variantPath('input.wrapper')
      },
      children: [label && displayLabel(label), _jsx("div", {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: [isSingleRow ? 'row' : 'column', 'row']
        },
        children: children.map(function (child, key) {
          return _jsx("div", {
            sx: {
              width: [isSingleRow ? '30%' : '100%', '30%'],
              marginTop: [isSingleRow ? 0 : 'xs', 0],
              '&:first-of-type': {
                marginTop: 0
              }
            },
            children: _jsx(FormStepField, {
              field: _objectSpread(_objectSpread({}, child), {}, {
                fieldVariant: fieldVariant
              }),
              register: register,
              errors: errors,
              setValue: setValue,
              getValues: getValues,
              formType: formType,
              variant: variant,
              goToPage: goToPage,
              updateCompletionState: updateCompletionState,
              onKeyDownFunction: onKeyDownFunction,
              isChild: true
            })
          }, key);
        }, this)
      })]
    }) : null, type === 'radio' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.radio.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsx("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('simple-radio.radioWrapper.variants.calculator') : variantPath('simple-radio.radioWrapper')
        },
        children: options.map(function (_ref2, i) {
          var label = _ref2.label,
              value = _ref2.value,
              _ref2$defaultChecked = _ref2.defaultChecked,
              defaultChecked = _ref2$defaultChecked === void 0 ? false : _ref2$defaultChecked,
              toolTip = _ref2.toolTip;
          return _jsx("div", {
            sx: {
              variant: formType === 'calculator' ? variantPath('simple-radio.span.variants.calculator') : variantPath('simple-radio.span')
            },
            children: _jsx(SimpleRadio, {
              defaultChecked: defaultChecked,
              label: label,
              name: name,
              value: value,
              ref: ref,
              onClick: handleTrackInteraction,
              toolTip: toolTip
            }, i)
          }, i);
        })
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error'),
          position: 'relative',
          top: 0
        },
        children: errors[name].message
      }) : null]
    }) : null, type === 'radio-horizontal' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.radio.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsx("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('simple-radio.radioWrapper.variants.calculator') : variantPath('simple-radio.radioWrapper'),
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        children: options.map(function (_ref3, i) {
          var label = _ref3.label,
              value = _ref3.value,
              _ref3$defaultChecked = _ref3.defaultChecked,
              defaultChecked = _ref3$defaultChecked === void 0 ? false : _ref3$defaultChecked;
          return _jsx("div", {
            sx: {
              variant: formType === 'calculator' ? variantPath('simple-radio.span.variants.calculator') : variantPath('simple-radio.span'),
              width: 'calc(50% - 8px)'
            },
            children: _jsx(SimpleRadio, {
              defaultChecked: defaultChecked,
              label: label,
              name: name,
              value: value,
              ref: ref,
              onClick: handleTrackInteraction,
              hasError: errors[name]
            }, i)
          }, i);
        })
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error'),
          position: 'relative',
          top: 0
        },
        children: errors[name].message
      }) : null]
    }) : null, type === 'checkbox' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.checkbox.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsx("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('checkbox.wrapper.variants.calculator') : variantPath('checkbox.wrapper')
        },
        children: options.map(function (_ref4, i) {
          var label = _ref4.label,
              value = _ref4.value,
              _ref4$defaultChecked = _ref4.defaultChecked,
              defaultChecked = _ref4$defaultChecked === void 0 ? false : _ref4$defaultChecked;
          return _jsx("div", {
            sx: {
              variant: formType === 'calculator' ? variantPath('checkbox.span.variants.calculator') : variantPath('checkbox.span')
            },
            children: _jsx(SimpleCheckbox, {
              defaultChecked: defaultChecked,
              label: label,
              value: value,
              name: name,
              ref: ref,
              onBlur: handleTrackInteraction
            }, i)
          }, i);
        })
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error')
        },
        children: errors[name].message
      }) : null]
    }) : null, type === 'autoComplete' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsx(SuggestionBox, {
        ref: ref,
        name: name,
        placeholder: placeholder,
        suggestionData: suggestionData
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error'),
          position: 'relative',
          top: 'sm'
        },
        children: errors[name].message
      }) : null]
    }) : null, type === 'summary' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.wrapper')
      },
      children: [_jsx("h2", {
        children: title
      }), _jsx("ul", {
        children: Object.entries(summaryList).map(function (_ref5, i) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          return _jsxs("li", {
            sx: {
              display: 'flex'
            },
            children: [key, ": ", formatter(getValues(value.value), value.type), _jsx("button", {
              type: "button",
              sx: {
                textDecoration: 'underline',
                cursor: 'pointer'
              },
              onClick: function onClick() {
                updateCompletionState(i, false);
                goToPage(i);
              },
              children: "Edit"
            })]
          }, i);
        })
      }), errors[name] ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          variant: variantPath('input.error')
        },
        children: errors[name].message
      }) : null]
    }) : null, type === 'input' || type === 'tel' ? _jsxs("div", {
      sx: {
        variant: formType === 'calculator' ? variantPath('input.wrapper.calculator') : isSingleRow ? variantPath('input.singleRow') : variantPath('input.wrapper')
      },
      children: [label && displayLabel(label), description && displayDescription(description), _jsxs("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('wrapper.variants.calculator') : variantPath('wrapper.base')
        },
        children: [mask ? _jsx(InputMask, {
          name: name,
          type: type,
          maskChar: 0,
          onChange: onChange,
          mask: mask,
          onKeyDown: onKeyDown,
          children: function children(inputProps) {
            return _jsx(SimpleInput, _objectSpread(_objectSpread({
              prefix: prefix,
              suffix: suffix,
              ref: ref
            }, inputProps), {}, {
              hasError: errors[name],
              name: name,
              placeholder: props.placeholder,
              onChange: onChange,
              onKeyDown: onKeyDown,
              onBlur: handleTrackInteraction
            }));
          }
        }) : _jsx(SimpleInput, {
          prefix: prefix,
          suffix: suffix,
          ref: ref,
          hasError: errors[name],
          onChange: onChange,
          name: name,
          type: type,
          placeholder: props.placeholder,
          onKeyDown: onKeyDown,
          onBlur: handleTrackInteraction
        }), subtext && _jsx("p", {
          sx: {
            textAlign: 'left'
          },
          children: subtext
        }), consentObj && _jsxs(React.Fragment, {
          children: [fieldVariant === 'consent' && _jsx("p", {
            sx: {
              fontWeight: 'bold',
              mt: 'xl'
            },
            children: "Keep in touch with us?"
          }), _jsxs("div", {
            sx: {
              variant: 'elements.input.consent.wrapper',
              marginTop: 'sm',
              textAlign: 'left'
            },
            children: [fieldVariant === 'consentMoney' && _jsx("p", {
              sx: {
                variant: 'elements.input.consent.question'
              },
              children: "Want to stay in touch?"
            }), _jsx(Checkbox, {
              defaultChecked: false,
              label: consentObj.text,
              name: "".concat(name, "-checkbox"),
              ref: register,
              onBlur: handleTrackInteraction,
              sx: {
                variant: 'elements.input.checkbox.variants.consent'
              },
              children: _jsxs("div", {
                children: [_jsx("p", {
                  sx: {
                    variant: 'elements.input.consent.text',
                    my: '0'
                  },
                  children: consentObj.text
                }), fieldVariant === 'consent' && _jsxs("small", {
                  children: ["You can unsubscribe at any time.", ' ', _jsx(Link, {
                    href: (privacyPolicyLink === null || privacyPolicyLink === void 0 ? void 0 : privacyPolicyLink.href) || '/',
                    sx: {
                      color: 'grey-80'
                    },
                    children: (privacyPolicyLink === null || privacyPolicyLink === void 0 ? void 0 : privacyPolicyLink.name) || 'Privacy policy'
                  })]
                })]
              })
            })]
          })]
        }), errors[name] ? _jsx(InputAlert, {
          type: "alert",
          sx: {
            pl: '0',
            pr: '0',
            variant: variantPath('input.error')
          },
          children: errors[name].message
        }) : null]
      })]
    }) : null, type === 'text' || type === 'redirect' ? _jsxs("div", {
      sx: {
        variant: variantPath('input.wrapper')
      },
      children: [_jsx("label", {
        sx: {
          variant: variantPath('label')
        },
        children: label
      }), _jsx("div", {
        sx: {
          pointerEvents: 'auto',
          variant: type === 'redirect' ? variantPath('redirect-text') : ''
        },
        dangerouslySetInnerHTML: {
          __html: textField
        }
      })]
    }) : null]
  });
};

export default FormStepField;
//# sourceMappingURL=form-step-field.js.map